export default __webpack_public_path__ + "static/media/backgroundSFX.819271cf.mp3";